import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { ScaleLoader } from 'react-spinners';
import { Collapse } from 'reactstrap';
import { RowContent, RowHeader } from './TableRow';

class CollapsibleTable extends React.PureComponent {
  state = {
    indexViewer: -1,
  };

  tableRef = React.createRef();

  componentDidMount() {
    this.injectJquery();
  }

  injectJquery = () => {
    const { fixedHeader } = this.props;
    if (!fixedHeader) return null;
    window.jQuery(this.tableRef.current).on('scroll', () => {
      window
        .jQuery(this.tableRef.current)
        .find('thead th')
        .css('transform', `translateY(${window.jQuery(this.tableRef.current).scrollTop()}px)`);
    });
  };

  onClickRow = (e, item, indexItem) => {
    const { indexViewer } = this.state;
    this.setState({ indexViewer: indexViewer === indexItem ? -1 : indexItem });
    const { onClickRow } = this.props;
    if (onClickRow) {
      onClickRow(e, item, indexItem);
    }
  };

  renderItemRemoveIndex = () => {};

  render() {
    const {
      fixedHeader,
      columns,
      data,
      rowClass,
      noDataMessage,
      getRowClass,
      sorted,
      onSort,
      tableClass,
      nullIsLoading,
      isLoading,
      indexParent, // Using when map & render table
      onCheckAll,
      dataExpand,
      listSwitchActive,
      t,
      ExpandRow,
      children,
      indexViewer,
      isSupportRemoveIndex,
      isViewOnly,
      isFixedHeaderTable,
      isNoNeedFixedHeader,
    } = this.props;
    // const { indexViewer } = this.state;
    return (
      <div
        className={`table-responsive mt-15 ${
          isNoNeedFixedHeader || fixedHeader ? 'no-stick' : 'sticky-parent-header'
        } table-form ${tableClass} ${fixedHeader ? 'tableFixHead' : ''}`}
        ref={this.tableRef}
      >
        <table
          className={`table center-aligned-table mb-0 ${isViewOnly ? 'table-collapsible-viewer' : 'table-collapsible'}`}
        >
          <thead>
            <RowHeader
              columns={columns}
              sorted={sorted}
              onSort={onSort}
              isLoading={isLoading}
              onCheckAll={onCheckAll}
              t={t}
            />
          </thead>
          <tbody>
            {!isLoading &&
              data &&
              data.map((item, idx) => {
                if (isSupportRemoveIndex && Object.keys(item).length < 2) return '';
                return [
                  <RowContent
                    key={`row-${idx}`}
                    columns={columns}
                    item={item}
                    onClickRow={this.onClickRow}
                    className={`${rowClass} ${
                      dataExpand && listSwitchActive && item.id === dataExpand.id ? 'acitve' : ''
                    }`}
                    getRowClass={getRowClass}
                    indexParent={indexParent}
                    indexItem={idx}
                    ExpandRow={ExpandRow || (() => {})}
                    activeTab={indexViewer === idx}
                  />,
                  <tr key={`key-${idx}`}>
                    <td colSpan={columns.length + 1} className="p-0">
                      <Collapse isOpen={indexViewer === idx} className="collapse__content">
                        {children}
                      </Collapse>
                    </td>
                  </tr>,
                ];
              })}
            {(isLoading || !data || data.length === 0) && (
              <tr>
                <td colSpan={columns.length + 1} className="text-center">
                  {!isLoading && !nullIsLoading && <span>{noDataMessage || t('label.noRecord')}</span>}
                  {(isLoading || ((!data || data.length === 0) && nullIsLoading)) && (
                    <ScaleLoader loading size={100} color="#28a745" />
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

CollapsibleTable.propTypes = {
  columns: PropTypes.array.isRequired,
  sorted: PropTypes.object,
  data: PropTypes.array.isRequired,
  rowClass: PropTypes.string,
  tableClass: PropTypes.string,
  noDataMessage: PropTypes.string,
  nullIsLoading: PropTypes.bool,
  isLoading: PropTypes.bool,
  getRowClass: PropTypes.func,
  onCheckAll: PropTypes.func,
  onSort: PropTypes.func,
  fixedHeader: PropTypes.bool,
  indexParent: PropTypes.number,
};

CollapsibleTable.defaultProps = {
  columns: [],
  sorted: {},
  data: [],
  rowClass: '',
  tableClass: '',
  getRowClass: null,
  isLoading: false,
  nullIsLoading: false,
  onSort: null,
  noDataMessage: '',
  fixedHeader: false,
  indexParent: 0,
  onCheckAll: () => {},
};

export default withTranslation('common')(CollapsibleTable);
